import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, } from 'react-bootstrap';
import AsyncActionButton from '../button/AsyncActionButton';

class Confirm extends React.Component {
  showTitle() {
    const { title, } = this.props;

    return title;
  }

  showContentText() {
    const { content, } = this.props;

    return content;
  }

  render() {
    const {
      open, onClose, onYes, onNo, isLoading,
    } = this.props;

    return (
      <Modal show={open} onHide={onClose} aria-labelledby="alert-dialog-title">
        <Modal.Header closeButton>
          <Modal.Title id="alert-dialog-title">{this.showTitle()}</Modal.Title>
        </Modal.Header>
        <Modal.Body id="alert-dialog-description">
          {this.showContentText()}
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={onNo} variant="outline-dark">
            No
          </Button>
          <AsyncActionButton
            onClick={onYes}
            contents="Yes"
            isLoading={isLoading}
            variant="primary"
            loadingVariant="secondary"
          />
        </Modal.Footer>
      </Modal>
    );
  }
}

Confirm.defaultProps = {
  open: undefined,
  isLoading: undefined,
  title: undefined,
  content: undefined,
};

Confirm.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.instanceOf(Function).isRequired,
  onYes: PropTypes.instanceOf(Function).isRequired,
  onNo: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool,
  title: PropTypes.string,
  content: PropTypes.node,
};

export default Confirm;
